import { Injectable, NgZone, ElementRef } from '@angular/core';
import { ColumnForSelection } from 'src/app/shared/import/column-for-selection';

@Injectable({
    providedIn: 'root'
})
export class ColumnScrollService {

    constructor(private ngZone: NgZone) { }

    public scrollToSelectedColumn(tableContainer: ElementRef, columns: ColumnForSelection[]): void {
        if (!tableContainer || !columns) {
            return;
        }

        // Find the first selected column
        const selectedColumnIndex = columns.findIndex(col => col.isSelected);
        if (selectedColumnIndex === -1) {
            return;
        }

        this.scrollToColumnAtIndex(tableContainer, selectedColumnIndex);
    }

    public scrollToFirstColumnWarning(tableContainer: ElementRef, columnWarnings: any[][]): void {
        if (!tableContainer || !columnWarnings) {
            return;
        }

        const firstWarningColumnIndex = columnWarnings.findIndex(warnings => warnings && warnings.length > 0);
        if (firstWarningColumnIndex === -1) {
            return;
        }

        this.scrollToColumnAtIndex(tableContainer, firstWarningColumnIndex);
    }

    private scrollToColumnAtIndex(tableContainer: ElementRef, columnIndex: number): void {
        this.ngZone.runOutsideAngular(() => {
            setTimeout(() => {
                const tableElement = tableContainer.nativeElement;
                const headerCells = tableElement.querySelectorAll('.header .cell');
                
                if (headerCells && headerCells[columnIndex]) {
                    const targetCell = headerCells[columnIndex] as HTMLElement;
                    const containerScrollLeft = tableElement.scrollLeft;
                    const containerWidth = tableElement.clientWidth;
                    const cellOffsetLeft = targetCell.offsetLeft;
                    const cellWidth = targetCell.offsetWidth;

                    // Calculate if the target column is visible
                    const cellLeftVisiblePos = cellOffsetLeft - containerScrollLeft;
                    const cellRightVisiblePos = cellLeftVisiblePos + cellWidth;

                    // Scroll to center the target column if it's not fully visible
                    if (cellLeftVisiblePos < 0 || cellRightVisiblePos > containerWidth) {
                        const scrollPosition = cellOffsetLeft - (containerWidth / 2) + (cellWidth / 2);
                        tableElement.scrollTo({
                            left: Math.max(0, scrollPosition),
                            behavior: 'smooth'
                        });
                    }
                }
            }, 50);
        });
    }
}
